import type WaPage from "@web.awesome.me/webawesome-pro/dist/components/page/page.js";
import { checkNotNil } from "./check-not-nil";

/**
Takes the text provided and decodes it assuming HTML encoding.
*/
export function htmlDecode(text: string): string {
  const doc = new DOMParser().parseFromString(text, "text/html");
  return doc.documentElement.textContent;
}

/**
Syncs the validity of the element internals with that of the known validation
target.
*/
export function setInternalsValidityFromTarget(
  internals: ElementInternals,
  target:
    | HTMLInputElement
    | HTMLTextAreaElement
    | HTMLSelectElement
    | null
    | undefined,
): void {
  if (target == null) {
    return;
  }

  if (!target.validity.valid) {
    internals.setValidity(target.validity, target.validationMessage, target);
  } else {
    internals.setValidity({});
  }
}

/**
Queries the WaPage from the document.
*/
export function queryPage(): WaPage {
  return checkNotNil(document.querySelector("wa-page"));
}

// TODO: Taken from @infra-blocks/types and copied here. Something within that
// library doesn't play well with ESM, or non Node.js environment. Gotta
// investigate...
export function trusted<T>(value: unknown): T {
  return value as T;
}
